// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"f3733d4f","327":"fdb8917d","387":"75b0a98e"}[chunkId] + ".css";
};